import React from "react";

export default function WeatherForecastDay(props) {
  function formatDay(timestamp) {
    let date = new Date(timestamp * 1000);
    let day = date.getDay();
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    return days[day];
  }

  return (
    <div className="WeatherForecastDay">
      <div className="col">
        <div className="WeatherForecast-day">{formatDay(props.data.dt)}</div>
        <img
          src={`https://openweathermap.org/img/wn/${props.data.weather[0].icon}@2x.png`}
          alt="weather icon"
          width="42"
        />
        <div className="WeatherForecast-temperature">
          <span className="WeatherForecast-temperature-max">
            <strong>{props.data.temp.max.toFixed(0)}°</strong> {""}
          </span>
          <span className="WeatherForecast-temperature-min">
            {props.data.temp.min.toFixed(0)}°
          </span>
        </div>
      </div>
    </div>
  );
}
